import React from 'react'
import { Icon } from '@chakra-ui/react'
import { gql, useMutation } from '@apollo/client'
import { FaArrowsRotate } from 'react-icons/fa6'

import SharedButton from '~components/shared/buttons/shared-button'
import { useClinic } from '~contexts/clinic-context'
import { useToastFeedback } from '~utils/hooks/use-toast-feedback'
import { isCloudPMS } from '~utils/pms-helpers'
import {
    namedOperations,
    PatientFieldsFragmentDoc,
} from '~graphql/generated/graphql'

const SYNC_INDIVIDUAL_PATIENT = gql`
    mutation syncIndividualPatient($patientId: ID!, $clinicId: ID!) {
        syncIndividualPatient(patientId: $patientId, clinicId: $clinicId) {
            ...PatientFields
        }
    }
    ${PatientFieldsFragmentDoc}
`

interface Props {
    patient: {
        id: string
        pms_id?: string | null
    }
}

export default function SyncIndividualPatientButton({ patient }: Props) {
    const { clinic } = useClinic()
    const { onCompleted, onError } = useToastFeedback(
        'Patient synced from PIMS.',
        'Failed to sync patient from PIMS.',
    )

    const [syncPatient, { loading }] = useMutation(SYNC_INDIVIDUAL_PATIENT, {
        onCompleted,
        onError,
        refetchQueries: [namedOperations.Query.getPatient],
        awaitRefetchQueries: true,
    })

    if (!clinic?.id || !patient.pms_id || !isCloudPMS(clinic.pms)) {
        return null
    }

    return (
        <SharedButton
            size="sm"
            variant="outline"
            leftIcon={<Icon as={FaArrowsRotate} />}
            isLoading={loading}
            onClick={() =>
                syncPatient({
                    variables: {
                        patientId: patient.id,
                        clinicId: clinic.id,
                    },
                })
            }
        >
            Sync from PIMS
        </SharedButton>
    )
}
